// Modules
import { useCallback } from 'react'
import { useTracking } from 'react-tracking'

// Application
import { User } from 'typings/auth'
import { getLoginSuccessData } from 'utils/analytics'

export const useLoginSuccess = () => {
    const { trackEvent } = useTracking()

    const dispatchLoginSuccess = useCallback(
        (
            user: User,
            analyticsData: {
                loginType?: string
                externalStep?: 'LOGIN' | 'PHASED_LOGIN' | 'PHASED_LOGIN_CADASTRO' | 'RECOVER_PASSWORD_LOGIN' | string
                cip?: string
                birthDate?: string
                rememberMe?: boolean
            } = {},
        ) => {
            if (
                ['LOGIN', 'PHASED_LOGIN', 'PHASED_LOGIN_CADASTRO', 'RECOVER_PASSWORD_LOGIN'].includes(analyticsData.externalStep || '')
            ) {
                const event = analyticsData.externalStep as
                    | 'LOGIN'
                    | 'PHASED_LOGIN'
                    | 'PHASED_LOGIN_CADASTRO'
                    | 'RECOVER_PASSWORD_LOGIN'
                trackEvent(
                    getLoginSuccessData({
                        user,
                        cip: analyticsData.cip,
                        loginType: analyticsData.loginType,
                        externalStep: event,
                        birthDate: analyticsData.birthDate,
                        rememberMe: analyticsData.rememberMe,
                    }),
                )
            }
        },
        [trackEvent],
    )

    return {
        dispatchLoginSuccess,
    }
}
